import React, { useState } from "react";
import "./Navigation.css";

interface NavigationProps {
  onNewsletterClick: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onNewsletterClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  const handleNewsletterClick = () => {
    onNewsletterClick();
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => scrollToSection("hero")}>
          <img
            src="/theinnerjourneylogo.svg"
            alt="The Inner Journey"
            className="nav-logo-img"
          />
          <h3 className="nav-title">&nbsp;The Inner Journey</h3>
        </div>
        <button
          className={`mobile-menu-toggle ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
          <li>
            <div onClick={() => scrollToSection("meet-therapist")}>About</div>
          </li>
          <li>
            <div onClick={() => scrollToSection("my-approach")}>Approach</div>
          </li>
          <li>
            <div onClick={() => scrollToSection("when-ready")}>
              Book a session
            </div>
          </li>
          <li>
            <div onClick={handleNewsletterClick}>Newsletter</div>
          </li>
          <li>
            <div onClick={() => scrollToSection("query-box")}>Contact</div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
